import React,{ useContext } from 'react';
import AuthContext from "../context/AuthContext.js";
import {BrowserRouter as Router,Route,Switch} from 'react-router-dom'
import {Redirect} from 'react-router'
import MainLayout from '../layouts/MainLayout/index.js'
import ProtectedLayout from '../layouts/ProtectedLayout/index.js'
import NotFound from '../pages/NotFound/index.js'
import Loading from '../components/Loading/index.js'


//Import Pages
import Home from '../pages/Home/index.js'
import Login from '../pages/Login/index.js'
import Signup from '../pages/Signup/index.js'
import Settings from '../pages/Settings/index.js'
import Verify from '../pages/Verify/index.js'
import ForgotPassword from '../pages/ForgotPassword/index.js'
import ResumeList from '../pages/ResumeList/index.js'
import Contact from '../pages/Contact/index.js'
import About from '../pages/About/index.js'
import Resume from '../pages/Resume/index.js'
import AddResume from '../pages/AddResume/index.js'
import Templates from '../pages/Templates/index.js'

function Index() {

    let AuthContextData = useContext(AuthContext);

    return (
        <>
        <Router>
          <Switch>
            <Route exact path="/contact">
                <MainLayout>
                    <Contact/>
                </MainLayout>
            </Route>
            <Route exact path="/about">
                <MainLayout>
                    <About/>
                </MainLayout>
            </Route>
            <Route exact path="/templates">
                <MainLayout>
                  <Templates/>
                </MainLayout>
            </Route>
            <Route exact path="/">
                <MainLayout>
                    <Home/>
                </MainLayout>
            </Route>


            {/* Logged In Only Routes */}
            <Route exact path="/resume/add">
              {AuthContextData.loginStatus === undefined && <MainLayout><Loading type="withImage"/></MainLayout>}
              {AuthContextData.loginStatus === 'LOGGED_IN' && <ProtectedLayout><AddResume/></ProtectedLayout>}
              {AuthContextData.loginStatus === 'LOGGED_OUT' && <Redirect to="/"/>}
            </Route>
            <Route exact path="/resume/:id">
              {AuthContextData.loginStatus === undefined && <MainLayout><Loading type="withImage"/></MainLayout>}
              {AuthContextData.loginStatus === 'LOGGED_IN' && <ProtectedLayout><Resume/></ProtectedLayout>}
              {AuthContextData.loginStatus === 'LOGGED_OUT' && <Redirect to="/"/>}
            </Route>
            <Route exact path="/resume">
              {AuthContextData.loginStatus === undefined && <MainLayout><Loading type="withImage"/></MainLayout>}
              {AuthContextData.loginStatus === 'LOGGED_IN' && <ProtectedLayout><ResumeList/></ProtectedLayout>}
              {AuthContextData.loginStatus === 'LOGGED_OUT' && <Redirect to="/"/>}
            </Route>
            <Route exact path="/settings">
              {AuthContextData.loginStatus === undefined && <MainLayout><Loading type="withImage"/></MainLayout>}
              {AuthContextData.loginStatus === 'LOGGED_IN' && <ProtectedLayout><Settings/></ProtectedLayout>}
              {AuthContextData.loginStatus === 'LOGGED_OUT' && <Redirect to="/"/>}
            </Route>


            {/* Logged Out Only Routes */}
            <Route exact path="/reset/:id/:otp">
              {AuthContextData.loginStatus === undefined && <MainLayout><Loading type="withImage"/></MainLayout>}
              {AuthContextData.loginStatus === 'LOGGED_OUT' && <MainLayout><ForgotPassword/></MainLayout>}
              {AuthContextData.loginStatus === 'LOGGED_IN' && <Redirect to="/resume"/>}
            </Route>
            <Route exact path="/verify/:id/:otp">
              {AuthContextData.loginStatus === undefined && <MainLayout><Loading type="withImage"/></MainLayout>}
              {AuthContextData.loginStatus === 'LOGGED_OUT' && <MainLayout><Verify/></MainLayout>}
              {AuthContextData.loginStatus === 'LOGGED_IN' && <Redirect to="/resume"/>}
            </Route>
            <Route exact path="/login">
              {AuthContextData.loginStatus === undefined && <MainLayout><Loading type="withImage"/></MainLayout>}
              {AuthContextData.loginStatus === 'LOGGED_OUT' && <MainLayout><Login/></MainLayout>}
              {AuthContextData.loginStatus === 'LOGGED_IN' && <Redirect to="/resume"/>}
            </Route>
            <Route exact path="/signup">
              {AuthContextData.loginStatus === undefined && <MainLayout><Loading type="withImage"/></MainLayout>}
              {AuthContextData.loginStatus === 'LOGGED_OUT' && <MainLayout><Signup/></MainLayout>}
              {AuthContextData.loginStatus === 'LOGGED_IN' && <Redirect to="/resume"/>}
            </Route>


            <Route>
                <MainLayout>
                    <NotFound/>
                </MainLayout>
            </Route>
          </Switch>
        </Router>
        </>
    )
}

export default Index
